import { CustomReport } from '@principle-theorem/principle-core';
import {
  ICustomReport,
  ICustomReportData,
  IQueryScopeRequests,
  ReportBuilderDataSourceId,
} from '@principle-theorem/principle-core/interfaces';
import { DocumentReference, ITimePeriod } from '@principle-theorem/shared';
import { ReportBuilderDataSource } from './data-sources/report-builder-data-source';
import { ReportBuilderDataSourceInstance } from './data-sources/report-builder-data-source-instance';
import {
  REPORT_BUILDER_DATA_SOURCES,
  resolveDataSource,
} from './data-sources/report-builder-data-sources';
import { CustomReportFilter } from './models/custom-report-filters';

export interface IReportBuilderQueryForm {
  dataSource: ReportBuilderDataSourceId;
  scopeRequests: IQueryScopeRequests;
}

export interface IReportBuilderQuery
  extends ICustomReportData,
    IReportBuilderQueryForm {
  filterDate: moment.Moment;
  filterDateRange: ITimePeriod;
  editMode: boolean;
  clearCurrentResults: boolean;
  customReportRef?: DocumentReference<ICustomReport>;
}

export class ReportBuilderQuery {
  static applySelectedDatesToFilters(
    query: IReportBuilderQuery
  ): IReportBuilderQuery {
    query.staticFilters =
      query.staticFilters?.map((filter) =>
        CustomReportFilter.applyDates(
          filter,
          query.filterDate,
          query.filterDateRange
        )
      ) ?? [];

    return query;
  }

  static applyEditModeToColumns(
    query: IReportBuilderQuery
  ): IReportBuilderQuery {
    const dataSource = ReportBuilderQuery.getDataSource(query);
    if (!dataSource) {
      return query;
    }

    const requestedColumns =
      query.columns ?? ReportBuilderDataSource.getDefaultColumns(dataSource);
    query.columns = dataSource.getQueryColumns(
      !query.editMode ? requestedColumns : undefined
    );

    return query;
  }

  static applyEditModeToCharts(
    query: IReportBuilderQuery
  ): IReportBuilderQuery {
    const dataSource = ReportBuilderQuery.getDataSource(query);
    if (!dataSource) {
      return query;
    }

    const requestedCharts = query.chartSections
      ?.map((section) => section.charts)
      .flat();

    const charts = dataSource.getQueryCharts(
      !query.editMode ? requestedCharts : undefined
    );
    query.chartSections = [CustomReport.chartSection('Charts', charts)];

    return query;
  }

  static getDataSource(
    query: IReportBuilderQuery
  ): ReportBuilderDataSourceInstance | undefined {
    return resolveDataSource(query.dataSource, REPORT_BUILDER_DATA_SOURCES);
  }
}
